export const formatKeyValue = (key: string | undefined) => {
  if (!key) return '';
  return key.replace(/(.{4})(?=.{4})/g, '$1-');
};
